var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: { titulo: _vm.titulo, width: _vm.width },
      on: {
        closeModal: function($event) {
          return _vm.$emit("closeModal")
        }
      }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _c(
            "div",
            [
              _vm.arrayBuffer && _vm.isMultiple && !_vm.isImagem
                ? _c("app-pdf-slider", {
                    attrs: { documentosBytes: _vm.arrayBuffer },
                    on: { changePdfDownload: _vm.changePdfDownload }
                  })
                : !_vm.isImagem
                ? _c("app-pdf-viewer", { attrs: { bytes: _vm.arrayBuffer } })
                : _vm._e()
            ],
            1
          ),
          (_vm.bytes || _vm.base64) &&
          (!_vm.arrayBytes || !_vm.arrayBytes.length) &&
          _vm.isImagem &&
          _vm.visualizarDocumentosPDF
            ? _c("app-image-viewer", {
                attrs: { bytes: _vm.bytes, base64: _vm.base64 }
              })
            : _vm._e()
        ],
        1
      ),
      !_vm.imprimir && _vm.showFooter
        ? _c("template", { slot: "footer" }, [
            _c(
              "div",
              { staticClass: "flex" },
              [
                !_vm.isImagem
                  ? _c("el-button", { on: { click: _vm.downloadPdf } }, [
                      _c("i", { staticClass: "fal fa-file-pdf" }),
                      _c("span", [_vm._v("  Exportar PDF")])
                    ])
                  : _vm._e(),
                _vm.isImagem
                  ? _c("el-button", { on: { click: _vm.downloadPdf } }, [
                      _c("i", { staticClass: "fal fa-file-pdf" }),
                      _c("span", [_vm._v("  Exportar Imagem")])
                    ])
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.imprimir
        ? _c("template", { slot: "footer" }, [
            _c(
              "div",
              { staticClass: "flex" },
              [
                _c("el-button", { on: { click: _vm.imprimirPDF } }, [
                  _c("i", { staticClass: "fal fa-print" }),
                  _c("span", [_vm._v("  Imprimir")])
                ])
              ],
              1
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2bddadc4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bddadc4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppModalVisualizaPdf.vue
// module id = null
// module chunks = 